import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import i18n from '../../src/i18n/translate';
import Icon from '../components/Icon';

export default class GraphicCalendar extends React.Component {
  static propTypes = {
    displayDate: PropTypes.string
  };

  render() {
    const { displayDate } = this.props;

    let top = <Icon iconType="replay" />;
    let bottom = i18n.t('Ongoing');

    if(displayDate) {
      const date = moment(displayDate);

      top = `${date.format('MMM')} ${date.format('D')}`;
      bottom = `${date.format('YYYY')}`;
    }

    return (
      <div className="date-box-display">
        <div className="top">{top}</div>
        <div className="bottom">{bottom}</div>
      </div>
    );
  }
}
